var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonAcademic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1279",
    "data-name": "Group 1279",
    transform: "translate(-511 -703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_787",
    "data-name": "Path 787",
    transform: "translate(511 703)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 11.69999980926514 C 2.857009887695312 11.69999980926514 0.300000011920929 9.142990112304688 0.300000011920929 6 C 0.300000011920929 2.857009887695312 2.857009887695312 0.300000011920929 6 0.300000011920929 C 9.142990112304688 0.300000011920929 11.69999980926514 2.857009887695312 11.69999980926514 6 C 11.69999980926514 9.142990112304688 9.142990112304688 11.69999980926514 6 11.69999980926514 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 0.6000003814697266 C 3.022430419921875 0.6000003814697266 0.6000003814697266 3.022430419921875 0.6000003814697266 6 C 0.6000003814697266 8.977569580078125 3.022430419921875 11.39999961853027 6 11.39999961853027 C 8.977569580078125 11.39999961853027 11.39999961853027 8.977569580078125 11.39999961853027 6 C 11.39999961853027 3.022430419921875 8.977569580078125 0.6000003814697266 6 0.6000003814697266 M 6 0 C 9.31371021270752 0 12 2.68628978729248 12 6 C 12 9.31371021270752 9.31371021270752 12 6 12 C 2.68628978729248 12 0 9.31371021270752 0 6 C 0 2.68628978729248 2.68628978729248 0 6 0 Z",
    stroke: "none",
    fill: "#858585"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1278",
    "data-name": "Group 1278",
    transform: "translate(513.729 706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M6,3.163a1.692,1.692,0,0,0-1.451,0L2.357,4.19a.7.7,0,0,0-.275.952V6.763a.245.245,0,0,0,.491,0V5.51l1.974.925A1.692,1.692,0,0,0,6,6.436L8.187,5.409a.7.7,0,0,0,0-1.219Z",
    transform: "translate(-2 -3)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M5,12.915v1.214a.9.9,0,0,0,.453.8,4.447,4.447,0,0,0,1.837.633,4.447,4.447,0,0,0,1.837-.633.9.9,0,0,0,.453-.8V12.915l-1.357.636a2.182,2.182,0,0,1-1.868,0Z",
    transform: "translate(-4.018 -9.67)",
    fill: "#858585"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x2: 9,
    y2: 7,
    transform: "translate(512.5 705.5)",
    fill: "none",
    stroke: "#858585",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonAcademic);
export default __webpack_public_path__ + "static/media/non-academic.65b77eff993f78fcc9812dcf575e3a2d.svg";
export { ForwardRef as ReactComponent };